import { useState } from "react";
import { RequiredPagesType, UseFileUploadErrorStateType } from "../types";

export const useFileUploadError = (requiredPages: Array<RequiredPagesType>) => {
  const [errors, setErrors] = useState<UseFileUploadErrorStateType>(
    requiredPages.reduce((acc, val) => ({ ...acc, [val]: null }), {} as UseFileUploadErrorStateType)
  );

  const onError = (msg: string, side: string) => {
    setErrors((prev) => ({ ...prev, [side]: msg }));
  };

  return { errors, onError };
};
